module.exports = __webpack_public_path__ + "static/media/mata-atlantica-thumbnail.9f837c3c.webp";